import { ActionTree } from 'vuex';
import axios from 'axios';
import { RootState } from '@/store/types';
import {OriginatorFilter, OriginatorItem, OriginatorsState} from './types';
import {directDownload} from "@/utils/download-helper";

export const actions: ActionTree<OriginatorsState, RootState> = {
  getOriginators: ({commit, dispatch}, data) => {
    // commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: '/acapi/originators', params: data})
        .then(resp => {
            if (data?.page_number > 1) {
                commit("pushOriginators", resp.data.originators);
            } else {
                commit('setOriginators', resp.data.originators);
            }
          resolve(resp.data.originators)
        })
        .catch(err => {
          // errorNotify(err);
          reject(err)
        })
        .finally(() => commit('setLoading', false))
      })
  },
  getOriginatorItem: ({commit, dispatch},id) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: `/acapi/originators/${id}`})
        .then((resp:any) => {
          let originatorItem = <OriginatorItem>resp.data;
          originatorItem.id = id;
          commit('setOriginatorItem', originatorItem);
          resolve(originatorItem)
        })
        .catch(err => {
          // errorNotify(err);
          reject(err)
        })
        .finally(() => commit('setLoading', false))
      })
  },
  saveOriginator: ({commit, dispatch}, data:OriginatorItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
          method: data.id ? 'put' : 'post',
          url: '/acapi/originators/' + (data.id ?? ''),
          data: data
      })
        .then((resp:any) => {
          console.log(resp.data);
          dispatch('getOriginators');
          resolve(resp)
        })
        .catch((err:any) => {
          // errorNotify(err);
          reject(err)
        })
        .finally(() => commit('setLoading', false))
      })
  },
  deleteOriginator: ({commit, dispatch}, data: OriginatorItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
          method: 'delete',
          url: `/acapi/originators/${data.id}`,
          data: data
      })
        .then((resp:any) => {
          dispatch('getOriginators');
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
      })
  },
  exportOriginators: ({commit, dispatch}, data: OriginatorFilter) => {
    return directDownload('/acapi/originators/export', data)
  },
};
